import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ui-input-text__label"
}
const _hoisted_2 = { class: "ui-input-text__input" }
const _hoisted_3 = ["name"]
const _hoisted_4 = ["name"]
const _hoisted_5 = {
  key: 1,
  class: "ui-input-text__error",
  "data-error": "true"
}

import { computed, onMounted } from 'vue'
import { MASKS } from '@/common/mask'
import { mask as vMask } from 'vue-the-mask'

// Use
import { useVModel } from '@vueuse/core'
import useThemeClassName from '@/hooks/useThemeClassName'

// Components
import HintText from '@/components/ui/HintText'

// Types
import type { Props } from './index'

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'InputText',
  props: {
    theme: {},
    label: {},
    focus: { type: Boolean },
    placeholder: {},
    name: {},
    modelValue: {},
    value: {},
    hint: {},
    mask: {},
    error: {}
  },
  emits: ["update:modelValue", "update:error"],
  setup(__props: any, { emit: __emit }) {

const props = __props

// Emits
const emit = __emit

// Data
let model = useVModel(props, 'modelValue', emit)
const proxiedError = useVModel(props, 'error', emit)


// Computed
const themeClassName = computed(() => useThemeClassName('ui-input-text', props.theme))
const text = computed<string | null>(() => props.placeholder ?? props.label ?? null)
const useMask = computed<boolean>(() => Boolean(props.mask && MASKS?.[props.mask]))

// Methods
function clearError(): void {
  proxiedError.value = null
}

onMounted(() => {
  if (props.value) {
    model.value = props.value
  }
})

return (_ctx: any,_cache: any) => {
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ui-input-text", [themeClassName.value]]),
    onClick: clearError
  }, [
    (text.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(text.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (useMask.value)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            type: "text",
            name: _ctx.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : model = $event))
          }, null, 8, _hoisted_3)), [
            [_directive_focus, _ctx.focus],
            [_vModelText, _unref(model)],
            [_unref(vMask), _unref(MASKS)[_ctx.mask]]
          ])
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            type: "text",
            name: _ctx.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(model) ? (model).value = $event : model = $event))
          }, null, 8, _hoisted_4)), [
            [_directive_focus, _ctx.focus],
            [_vModelText, _unref(model)]
          ])
    ]),
    (_unref(proxiedError))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(proxiedError)), 1))
      : _createCommentVNode("", true),
    (_ctx.hint)
      ? (_openBlock(), _createBlock(_unref(HintText), {
          key: 2,
          "link-text": _ctx.hint.link,
          "hint-text": _ctx.hint.text,
          class: "ui-input-text__hint"
        }, null, 8, ["link-text", "hint-text"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})